/** Borne des colonnes `company` et `department` côté API (`MAX_AFFILIATION_LENGTH`, #277). */
export const MAX_AFFILIATION_LENGTH = 200

/** Même contrôle que l'API : une société ou un service trop long refuse la ligne d'import. */
export function isAffiliationTooLong({ company, department }: { company?: string, department?: string }): boolean {
  return [company, department].some(value => (value?.trim().length ?? 0) > MAX_AFFILIATION_LENGTH)
}
